export const T = {
  navy: '#0A1428',
  navy2: '#0F1A33',
  navy3: '#142440',
  navyLine: 'rgba(245, 240, 230, 0.10)',
  navyLine2: 'rgba(245, 240, 230, 0.18)',
  cream: '#F5F0E6',
  creamMuted: 'rgba(245, 240, 230, 0.72)',
  creamDim: 'rgba(245, 240, 230, 0.50)',
  creamFaint: 'rgba(245, 240, 230, 0.30)',
  sage: '#A8C79E',
  sageDeep: '#5A8E4C',
  sageDarker: '#3E6934',
  paper: '#F5F0E6',
  paper2: '#EDE7D8',
  paperLine: '#D9D1BE',
  graphite: '#0A1428',
  graphiteMuted: '#4A5568',
  graphiteDim: '#6B7280',
  warn: '#C77A0A',
  warnBg: '#F9E9CE',
  fail: '#9B2C2C',
  failBg: '#F5D9D6',
  xeroBlue: '#13B5EA',
} as const;

export const sx = {
  container: { maxWidth: 1240, margin: '0 auto', padding: '0 40px' } as React.CSSProperties,
  label: { fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase' as const, fontWeight: 500, color: T.creamDim } as React.CSSProperties,
  labelLight: { fontSize: 11, letterSpacing: '0.14em', textTransform: 'uppercase' as const, fontWeight: 500, color: T.graphiteDim } as React.CSSProperties,
  serif: { fontFamily: "'Instrument Serif', serif", fontWeight: 400, letterSpacing: '-0.015em' } as React.CSSProperties,
  mono: { fontFamily: "'Geist Mono', monospace", fontVariantNumeric: 'tabular-nums' as const } as React.CSSProperties,
};
